export enum AssessmentScaledStatus {
    Approved = 1,
    Rejected = 2 ,
    Pending = 3
}

